
  import React from "react"
  import Component from "/builds/allgaeuer.fabian/risag.eu/src/layouts/index.js"
  import data from "/builds/allgaeuer.fabian/risag.eu/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js